import script from "./ModalEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEditor.vue?vue&type=style&index=0&id=1815e199&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1815e199"]])

export default __exports__